import * as React from 'react';
import { SVGProps } from 'react';

const SvgMomAndBaby = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill={props.fill}
      d="M5.415 32.564v4.911l16.45.025 4.897-4.896-21.347-.04Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M10.815 9.074v2.395a5.23 5.23 0 0 0 5.221 5.226 5.23 5.23 0 0 0 5.226-5.226V9.074"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M10.815 11.364v-2.4a5.225 5.225 0 0 1 10.447 0v2.4M7 33.272v-8.5a8.121 8.121 0 0 1 9.707-7.972c1.576.314 2.793.462 4.293 1.7"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M22.77 20.476a7.437 7.437 0 0 0-3.281-2.88M25 32.68V30.6M21.693 9.575a9.777 9.777 0 0 1-6.584-1.702 3.779 3.779 0 0 1-.548 1.125c-.518.716-1.56 1.59-3.574 1.59"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M11.204 6.38a4.383 4.383 0 0 0-2.6-.345A5.113 5.113 0 0 0 5 10.97v6.817l1.945-1.368c.38-.266 2.96-1.777 4.055-3.919"
    />
    <path
      fill="currentColor"
      d="m31.99 18.982-1.532-1.537.304-.277a2.21 2.21 0 0 1 3.113 0l-1.537 1.536a.031.031 0 0 0-.022-.009.031.031 0 0 0-.021.01l-.304.277Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m26.186 20.518-.444-.448a1.613 1.613 0 0 0-2.275 0l-3.219 3.226a4.288 4.288 0 0 0 0 6.05 4.228 4.228 0 0 0 3.033 1.254 4.236 4.236 0 0 0 3.03-1.262l3.219-3.226a1.617 1.617 0 0 0 0-2.28l-.459-.445"
    />
    <circle
      cx={29.2}
      cy={20}
      r={3.25}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path stroke="currentColor" strokeWidth={1.5} d="M20 23.35h10" />
  </svg>
);

export default SvgMomAndBaby;
